export enum YesNoInProgress {
  Yes = 'yes',
  No = 'no',
  InProgress = 'in_progress',
}

export const YES_NO_IN_PROGRESS_TRANSLATIONS = {
  [YesNoInProgress.Yes]: 'Ja',
  [YesNoInProgress.No]: 'Nein',
  [YesNoInProgress.InProgress]: 'Begonnen und noch nicht abgeschlossen',
};
